/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from './../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Driver-Outline Icon component.
 */
export const AssetDriverOutlinedIcon = (props: IconProps) => {
  const {color, size = IconSize.large, stroke} = props;
  const {iconSize} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
      <path d="M20.0011 18.32C22.9991 18.32 25.4295 15.9705 25.4295 13.0721C25.4295 10.1738 22.9991 7.82422 20.0011 7.82422C17.0031 7.82422 14.5728 10.1738 14.5728 13.0721C14.5728 15.9705 17.0031 18.32 20.0011 18.32Z" stroke={stroke as any} strokeWidth="1.5" strokeMiterlimit="10"/>
      <path d="M8.00098 27.5869C8.00098 24.2732 10.6873 21.5869 14.001 21.5869H25.0002C28.3139 21.5869 31.0002 24.2732 31.0002 27.5869V31.6748C31.0002 31.9509 30.7763 32.1748 30.5002 32.1748H8.50098C8.22483 32.1748 8.00098 31.9509 8.00098 31.6748V27.5869Z" stroke={stroke as any} strokeWidth="1.5"/>
    </svg>
  );
};

export default AssetDriverOutlinedIcon;
